<template>
  <div class="fillParent buttons-container" v-if="node">
    <CollapsedGroup class="buttons-group" innerClass="buttons-group-inner" v-if="!globalState.actVer && !globalState.projLock" :hidden="collapsed.folder" :ontoggle="()=>toggleCollapse('folder')">
      <template #title>{{$t('message.folder_actions')}}: <b>{{ folder ? folder.name : (node?.name+' (project)') }}</b></template>
      <ToolButton 
          vertical
          title="message.menu_create"
          icon="add_circle_outline"
          tool-tip="message.menu_create"
          helptoken="Create+element"
          v-if="!folder?.is_requirement && (folder || node)?.permissions?.can_i_write && !isFolderProduct && fs.show('Node.Create')" 
          :disabled="fs.disabled('Node.Create')"
          v-on:click.stop="()=>doActionOnFolder('createNode')"
      />
      <ToolButton 
          vertical
          title="message.menu_req"
          icon="add_circle_outline"
          tool-tip="message.menu_req"
          v-if="folder && folder.is_requirement && folder.permissions?.can_i_write && !isFolderProduct && fs.show('Node.AddRequirement')" 
          :disabled="fs.disabled('Node.AddRequirement')"
          v-on:click.stop="()=>doActionOnFolder('createReq')"
      />
      <ToolButton 
          vertical
          title="message.menu_add_org"
          icon="add_business"
          tool-tip="message.menu_add_org"
          helptoken="Add-Organisation"
          v-if="folder && !folder.is_part && !folder.is_requirement && folder.permissions?.can_i_write && !isFolderProduct && fs.show('Node.AddOrganization')" 
          :disabled="fs.disabled('Node.AddOrganization')" 
          v-on:click.stop="()=>doActionOnFolder('addOrgToNode')"
      />
      <ToolButton 
          vertical
          title="message.menu_put_prod"
          tool-tip="message.menu_put_prod"
          helptoken="Put-Product"
          v-if="folder && ((!folder.is_part && !folder.is_requirement && folder.permissions?.can_i_write) || isFolderProduct) && fs.show('Node.AddProduct')" 
          :disabled="fs.disabled('Node.AddProduct')"
          v-on:click.stop="()=>isFolderProduct ? doActionOnProductFolder('putProdToProd') : doActionOnFolder('putProdToNode')"
      >
        <template #icon>
          <svg width="24px" height="24px" viewBox="0 0 30 30"><path d="M5.3 3.6A2.3 2.3 0 0 0 3 5.8v3.4c0 1.1.9 1.9 1.8 2.2v11.4q.2 2 2.3 2.2h10v-2.7H7.5V11.6l.1-.2H21q.2 0 .2.2V17H24v-5.7q1.6-.4 1.8-2.2V5.8q-.2-2-2.3-2.2ZM6 6.3h17l.2.1v2.3l-.2.1H5.8V6.3"/><path d="M12.3 13.7q-.7 0-1 .4t-.3 1 .3.8 1 .4h4.2q.5 0 1-.5t.3-.9l-.3-.9-1-.3Z"/><path transform="translate(-.9 -.4)scale(1.05321)" d="m22.2 18-.1.1v3.5h-3.5l-.1.1v2.5h3.6v3.6h2.5v-3.5h3.6v-2.6h-3.5V18h-.1z"/></svg>
        </template>
      </ToolButton>
      <ToolButton
          vertical 
          title="message.menu_add_file"
          icon="file_present"
          tool-tip="message.menu_add_file"
          helptoken="Add+data+file"
          v-if="folder && folder.parent && !folder.is_part && folder.permissions?.can_i_write && !isFolderProduct && fs.show('Node.AddDataFile')" 
          :disabled="fs.disabled('Node.AddDataFile')"
          v-on:click.stop="()=>doActionOnFolder('addFileToNode')"
      />
      <ToolButton
          vertical 
          title="message.menu_gen_doc"
          icon="receipt_long"
          tool-tip="message.menu_gen_doc"
          helptoken="Generate-document"
          v-if="folder && !folder.is_part && !folder.is_requirement && folder.permissions?.can_i_write && !isFolderProduct && fs.show('Node.GenerateDocument')" 
          :disabled="fs.disabled('Node.GenerateDocument')"
          v-on:click.stop="()=>doActionOnFolder('genDocByTmpl')"
      />
      <ToolButton 
          vertical
          title="message.menu_create_baseline"
          icon="download_done"
          tool-tip="message.menu_create_baseline"
          helptoken="Create+baseline"
          v-if="globalState.curUserRole !== 'urn:rdl:epm-std:project_member' && !folder?.is_requirement && !isFolderProduct && fs.show('Project.Baseline.Create')" 
          :disabled="fs.disabled('Project.Baseline.Create')"
          v-on:click.stop="()=>doActionOnFolder('createBaseline')"
      />
    </CollapsedGroup>

    <CollapsedGroup class="buttons-group" innerClass="buttons-group-inner" :hidden="collapsed.node" :ontoggle="()=>toggleCollapse('node')">
      <template #title>{{$t('message.element_actions')}}: <b>{{(node?.title||node?.name)}}</b></template>
      <ToolButton 
          light vertical
          title="message.btn_copy"
          icon="content_copy"
          tool-tip="message.menu_copy"
          helptoken="Copy+element"
          v-if="!isFile && !isProduct && node?.parent && !globalState.actVer && !globalState.projLock && fs.show( 'Node.CopyPaste')" 
          :disabled="!node?.permissions?.can_i_write || fs.disabled('Node.CopyPaste')"
          v-on:click.stop="()=>doActionOnNode('copyNode')"
      />
      <ToolButton 
          light vertical
          title="message.btn_copy"
          icon="content_copy"
          tool-tip="message.menu_file_copy"
          helptoken="copy+file"
          v-if="isFile && !globalState.actVer && !globalState.projLock && fs.show('Node.CopyPasteFile')" 
          :disabled="!folder?.permissions?.can_i_write || fs.disabled('Node.CopyPasteFile')"
          v-on:click.stop="()=>doActionOnNode('copyFile')"
      />
      <ToolButton 
          light vertical
          title="message.btn_copy"
          icon="content_copy"
          tool-tip="message.menu_copy_prod"
          v-if="isProduct && !globalState.actVer && !globalState.projLock && fs.show('Node.CopyPasteFile')" 
          :disabled="fs.disabled('Node.CopyPasteFile')"
          v-on:click.stop="()=>doActionOnNode('copyProd')"
      />
      <ToolButton 
          light vertical
          title="message.btn_cut"
          icon="content_cut"
          tool-tip="message.menu_cut"
          helptoken="Cut+element"
          v-if="!isFile && !isProduct && node?.parent && !globalState.actVer && !globalState.projLock && fs.show('Node.CopyPaste')" 
          :disabled="!node?.permissions?.can_i_write || !node.permissions?.can_i_delete || fs.disabled('Node.CopyPaste')"
          v-on:click.stop="()=>doActionOnNode('cutNode')"
      />
      <ToolButton 
          light vertical
          title="message.btn_cut"
          icon="content_cut"
          tool-tip="message.menu_file_cut"
          helptoken="cut+file"
          v-if="isFile && !globalState.actVer && !globalState.projLock && fs.show('Node.CopyPasteFile')" 
          :disabled="!folder?.permissions?.can_i_write || !folder.permissions?.can_i_delete || fs.disabled('Node.CopyPasteFile')"
          v-on:click.stop="()=>doActionOnNode('cutFile')"
      />
      <ToolButton 
          light vertical danger
          title="message.btn_delete" 
          icon="delete_outline"
          tool-tip="message.menu_delete"
          helptoken="Delete+element"
          v-if="!isFile && !isProduct && node?.parent && !globalState.actVer && !globalState.projLock && fs.show('Node.Delete')" 
          :disabled="!node?.permissions?.can_i_delete || fs.disabled('Node.Delete')"
          v-on:click.stop="()=>doActionOnNode('deleteNode')"
      />
      <ToolButton 
          light vertical danger
          title="message.btn_delete" 
          icon="delete_outline"
          tool-tip="message.file_delete_btn"
          helptoken="Delete"
          v-if="isFile && !globalState.actVer && !globalState.projLock && fs.show('Document.Delete')" 
          :disabled="!folder?.permissions?.can_i_delete || fs.disabled('Document.Delete')"
          v-on:click.stop="()=>doActionOnNode('deleteFile')"
      />
      <ToolButton 
          light vertical danger
          title="message.btn_delete" 
          icon="delete_outline"
          tool-tip="message.menu_remove_prod"
          v-if="isProduct && !globalState.actVer && !globalState.projLock && fs.show('Product.Delete')" 
          :disabled="fs.disabled('Product.Delete')"
          v-on:click.stop="()=>doActionOnNode(node.parent.instance_id?'removeProdFromNode':'removeProdFromProd')"
      />

      <span class="groupped-buttons" v-if="!havePasteFile() && !folder?.is_requirement && (folder || node)?.permissions?.can_i_write && fs.show('Node.CopyPaste')">
        <ToolButton 
            light vertical groupStart
            title="message.btn_paste"
            icon="content_paste_go"
            tool-tip="message.menu_paste"
            helptoken="Paste+element"
            :disabled="!globalState.nodeForPaste || fs.disabled('Node.CopyPaste')"
            v-on:click.stop="()=>doActionOnFolder('pasteNode')"
        />
        <ToolButton
            light vertical groupMid
            title="message.btn_paste_relating" 
            icon="content_paste_go"
            tool-tip="message.menu_paste_rel1"
            helptoken="Paste+element+as+relating"
            :disabled="!globalState.nodeForPaste || fs.disabled('Node.CopyPaste')"
            v-on:click.stop="()=>doActionOnFolder('pasteNodeRel1')"
        />
        <ToolButton 
            light vertical groupEnd
            title="message.btn_paste_related" 
            icon="content_paste_go"
            tool-tip="message.menu_paste_rel2"
            helptoken="Paste+element+as+related"
            :disabled="!globalState.nodeForPaste || fs.disabled('Node.CopyPaste')"
            v-on:click.stop="()=>doActionOnFolder('pasteNodeRel2')"
        />
      </span>
      <span style="display: flex;flex: 1 1;" v-else-if="havePasteFile() && (folder || node)?.permissions?.can_i_write && fs.show('Node.CopyPasteFile')">
        <ToolButton 
            light vertical groupStart
            title="message.btn_paste"
            icon="content_paste_go"
            tool-tip="message.menu_paste_file"
            helptoken="Paste+data+file"
            :disabled="!canPasteFile() || fs.disabled('Node.CopyPasteFile') || !folder?.parent || folder?.is_part"
            v-on:click.stop="()=>doActionOnFolder('pasteFileToNode')"
        />
        <ToolButton
            light vertical groupMid
            title="message.btn_paste_affected" 
            icon="link"
            tool-tip="message.menu_file_link1"
            helptoken="Paste+file+as+affected"
            :disabled="!isFile || ( globalState.fileForLink.instance_id === node.instance_id ) || fs.disabled('Node.CopyPasteFile')"
            v-on:click.stop="()=>doActionOnNode('linkFile1')"
        />
        <ToolButton 
            light vertical groupEnd
            title="message.btn_paste_affecting" 
            icon="link"
            tool-tip="message.menu_file_link2"
            helptoken="Paste+file+as+affecting"
            :disabled="!isFile || ( globalState.fileForLink.instance_id === node.instance_id ) || fs.disabled('Node.CopyPasteFile')"
            v-on:click.stop="()=>doActionOnNode('linkFile2')"
        />
      </span>
      <template v-if="node && !isFile && !isProduct">
        <ToolButton 
            light vertical
            title="message.menu_show_node_tree"
            icon="list"
            tool-tip="message.menu_show_node_tree"
            helptoken="Show+element+in+context"
            v-if="fs.show('Node.ShowInContext')" 
            :disabled="fs.disabled('Node.ShowInContext')"
            v-on:click.stop="()=>showNodeTree()"
        />
        <ToolButton 
            light vertical
            title="message.menu_show_bom"
            icon="account_tree"
            :tool-tip="node.is_requirement ? 'message.menu_show_bom_req' : 'message.menu_show_bom'"
            helptoken="Show-Structure-Tree"
            v-if="fs.show('Node.ShowInTree')" 
            :disabled="fs.disabled('Node.ShowInTree')"
            v-on:click.stop="()=>showBOM()"
        />
        <ToolButton 
            light vertical
            icon="hub"
            title="message.list_gr_dt_graph"
            tool-tip="message.menu_show_node_graph"
            helptoken="Open-connection-graph"
            v-if="!node.is_requirement && !globalState.actVer && !globalState.projLock && fs.show('Node.ShowInGraph')" 
            :disabled="fs.disabled('Node.ShowInGraph')"
            v-on:click.stop="()=>showNodeGraph()"
        />
        <ToolButton 
            light vertical
            icon="history"
            title="message.file_hist_btn"
            tool-tip="message.menu_show_node_history"
            helptoken="View+Change+log"
            v-if="node.parent && !node.is_requirement && !globalState.actVer && !globalState.projLock && fs.show('Node.ViewChangeLog')" 
            :disabled="fs.disabled('Node.ViewChangeLog')"
            v-on:click.stop="()=>doActionOnNode( 'showNodeHistory' )"
        />
      </template>
      <template v-if="node && !isProduct && !globalState.actVer">
        <ToolButton 
            vertical light
            title="message.menu_add_issue"
            icon="post_add"
            tool-tip="message.menu_add_issue"
            helptoken="Issues"
            v-if="folder?.parent && !node.is_requirement && !node.is_part && !globalState.projLock && fs.show('Project.Issues.Create')" 
            :disabled="fs.disabled('Project.Issues.Create')"
            v-on:click.stop="()=>doActionOnNode('addIssue')"
        />
        <ToolButton 
            vertical light
            title="message.menu_send_msg"
            icon="send"
            tool-tip="message.menu_send_msg"
            :helptoken="isFile?'Personal-messages-(Task-or-Info-notifications)':'Personal-messages'"
            v-if="globalState.userMsgReady && !node.is_requirement && !globalState.projLock && fs.show('Messages.Send')" 
            :disabled="fs.disabled('Messages.Send')"
            v-on:click.stop="()=>doActionOnNode(isFile?'sendFileMsg':'sendMsg')"
        />
        <ToolButton 
            vertical light
            title="message.menu_file_notes"
            icon="note"
            tool-tip="message.menu_file_notes"
            helptoken="Sticky+notes"
            v-if="isFile && !globalState.projLock && fs.show('Document.Notes.View')" 
            :disabled="fs.disabled('Document.Notes.View')"
            v-on:click.stop="()=>doActionOnNode('openNotes')"
        />
        <ToolButton 
            vertical light
            title="message.menu_file_links"
            icon="dataset_linked"
            tool-tip="message.menu_file_links"
            helptoken="Dependencies"
            v-if="isFile && fs.show('Document.Dependencies.View')" 
            :disabled="fs.disabled('Document.Dependencies.View')"
            v-on:click.stop="()=>doActionOnNode('openLinks')"
        />
        <ToolButton 
            vertical light
            title="message.menu_inc_ver"
            icon="plus_one"
            tool-tip="message.menu_inc_ver"
            v-if="(!node.parent || !folder) && !globalState.projAutoVer && fs.show('RootNode.EditVersion')" 
            :disabled="fs.disabled('RootNode.EditVersion')"
            v-on:click.stop="()=>doActionOnNode('incVer')"
        />
        <ToolButton 
            vertical light
            title="message.menu_valid_model"
            icon="assignment_turned_in"
            tool-tip="message.menu_valid_model"
            v-if="(!node.parent || !folder) && fs.show('RootNode.Validate')" 
            :disabled="fs.disabled('RootNode.Validate')"
            v-on:click.stop="()=>doActionOnNode('validateModel')"
        />
        <ToolButton 
          vertical light
          title="message.menu_phase"
          icon="abc"
          tool-tip="message.menu_phase"
          helptoken="Current-project-phase"
          v-if="(!node.parent || !folder) && !globalState.projLock && fs.show('RootNode.SetPhase')" 
          :disabled="fs.disabled('RootNode.SetPhase')"
          v-on:click.stop="()=>doActionOnNode('setPhase')"
        />
        <v-autocomplete :items="verList" item-text="txt" item-value="val" placeholder="Version" hide-details v-if="(!node.parent || !folder)"
            v-model="selectedVer" @input="setActVer()" dense class="version-selector" :disabled="fs.disabled('RootNode.SelectVersion')"></v-autocomplete>
        <ToolButton 
          vertical light
          title="message.menu_unlock_proj"
          icon="lock_open"
          tool-tip="message.menu_unlock_proj"
          helptoken="Current-project-phase"
          v-if="(!node.parent || !folder) && globalState.projLock && fs.show('RootNode.LockProject')" 
          :disabled="fs.disabled('RootNode.LockProject')"
          v-on:click.stop="()=>doActionOnNode('unlockProj')"
        />
        <ToolButton 
          vertical light
          title="message.menu_lock_proj"
          icon="lock_outline"
          tool-tip="message.menu_lock_proj"
          helptoken="Current-project-phase"
          v-if="(!node.parent || !folder) && !globalState.projLock && fs.show('RootNode.LockProject')" 
          :disabled="fs.disabled('RootNode.LockProject')"
          v-on:click.stop="()=>doActionOnNode('lockProj')"
        />
      </template>
    </CollapsedGroup>
    
    <CollapsedGroup class="buttons-group" innerClass="buttons-group-inner" v-if="node && !globalState.actVer && isFile" :hidden="collapsed.document" :ontoggle="()=>toggleCollapse('document')">
      <template #title>{{$t('message.document_actions')}}: <b>{{node.title}}</b></template>
      <ToolButton 
          vertical light
          title="message.menu_file_checkout"
          icon="assignment_returned"
          tool-tip="message.menu_file_checkout"
          helptoken="Checkout+file"
          v-if="!node.is_checked_out_by_me && folder.permissions.can_i_write && fs.show('Document.Checkout')"
          :disabled="node.is_checked_out_by_someone_else || fs.disabled('Document.Checkout')"
          v-on:click.stop="()=>doActionOnNode('checkOutFile')"
      />
      <ToolButton 
          vertical light
          title="message.menu_file_checkout_cancel"
          icon="undo"
          tool-tip="message.menu_file_checkout_cancel"
          helptoken="Undo+checkout"
          v-if="node.is_checked_out_by_me && folder.permissions.can_i_write && fs.show('Document.UndoCheckout')"
          :disabled="fs.disabled('Document.UndoCheckout')"
          v-on:click.stop="()=>doActionOnNode('cancelCheckOutFile')"
      />
      <ToolButton 
          vertical light
          title="message.menu_file_checkin"
          icon="assignment_turned_in"
          tool-tip="message.menu_file_checkin"
          helptoken="Checkin+file"
          v-if="folder.permissions.can_i_write && fs.show('Document.Checkin')"
          :disabled="!node.is_checked_out_by_me || fs.disabled('Document.Checkin')"
          v-on:click.stop="()=>doActionOnNode('checkInFile')"
      />
      <ToolButton 
          vertical light
          title="message.menu_file_readonly_set"
          icon="edit_off"
          tool-tip="message.menu_file_readonly_set"
          helptoken="Set-file-read-only-/-Clear-file-read-only"
          v-if="!node.readonly && folder.permissions.can_i_write && fs.show('Document.SetReadonly')"
          :disabled="fs.disabled('Document.SetReadonly')"
          v-on:click.stop="()=>doActionOnNode('setFileReadOnly')"
      />
      <ToolButton 
          vertical light
          title="message.menu_file_readonly_clear"
          icon="edit"
          tool-tip="message.menu_file_readonly_clear"
          helptoken="Set-file-read-only-/-Clear-file-read-only"
          v-if="node.readonly && folder.permissions.can_i_write && fs.show('Document.SetReadonly')"
          :disabled="fs.disabled('Document.SetReadonly')"
          v-on:click.stop="()=>doActionOnNode('clearFileReadOnly')"
      />
      <ToolButton 
          vertical light
          title="message.file_download_btn"
          icon="sim_card_download"
          tool-tip="message.file_download_btn"
          helptoken="Download"
          v-if="fs.show('Document.Download')" 
          :disabled="fs.disabled('Document.Download')"
          v-on:click.stop="()=>doActionOnNode('downloadFile')"
      />
      <ToolButton 
          vertical light
          title="message.file_open_btn"
          icon="preview"
          tool-tip="message.file_open_btn"
          helptoken="Open"
          v-if="folder.permissions.can_i_read && fs.show('Document.Open')" 
          :disabled="fs.disabled('Document.Open')"
          v-on:click.stop="()=>doActionOnNode('openFile')"
      />
      <ToolButton 
          vertical light
          title="message.file_convert_btn"
          icon="picture_as_pdf"
          tool-tip="message.file_convert_btn"
          helptoken="VCollab-Visualization"
          v-if="node.permissions.can_i_write && globalState.initInfo.vcolab && isConvType && fs.show('Document.Convert2WCAX')"
          :disabled="fs.disabled('Document.Convert2WCAX')"
          v-on:click.stop="()=>doActionOnNode('convertFile')"
      />
      <ToolButton 
          vertical light
          title="message.file_hist_btn"
          icon="history"
          tool-tip="message.file_hist_btn"
          helptoken="View+history"
          v-if="folder.permissions.can_i_read && fs.show('Document.ViewHistory')" 
          :disabled="fs.disabled('Document.ViewHistory')"
          v-on:click.stop="()=>showHistory()"
      />
      <ToolButton 
          vertical light
          title="message.menu_file_pdf"
          icon="dataset_linked"
          tool-tip="message.menu_file_pdf"
          v-if="isFile && fs.show('Document.ConvertToPDF')" 
          :disabled="!readyForPDF || fs.disabled('Document.ConvertToPDF')"
          v-on:click.stop="()=>doActionOnNode('convertToPdf')"
      />
    </CollapsedGroup>

    <CollapsedGroup class="buttons-group" innerClass="buttons-group-inner" v-if="node && folder && !isFile && !isProduct && !node.is_requirement && (node.is_part_of_subdomain > 0 || (node.parent && !globalState.actVer && !globalState.projLock && !node.is_part && globalState.projType === 'Proj')) && fs.show('DomainManagment')" :hidden="collapsed.domains" :ontoggle="()=>toggleCollapse('domains')">
      <template #title>{{$t('message.btn_grp_domain_mgmt')}}</template>

      <ToolButton 
          vertical light
          title="message.menu_info_subdomain"
          icon="domain"
          tool-tip="message.menu_info_subdomain"
          helptoken="Subdomain-info"
          v-if="node.is_part_of_subdomain > 0 && !node.is_requirement && fs.show('Node.DomainManagment.View')" 
          :disabled="fs.disabled('Node.DomainManagment.View')"
          v-on:click.stop="()=>doActionOnNode('infoSubdomain')"
      />
      <template v-if="!globalState.actVer && node.parent && !node.is_requirement && !node.is_part && globalState.projType === 'Proj' && fs.show('DomainManagment')">
        <ToolButton 
          vertical light
          title="message.menu_create_subdomain"
          icon="domain_add"
          tool-tip="message.menu_create_subdomain"
          helptoken="Subdomain-management"
          v-if="!node.is_root_of_subdomain && fs.show('Node.DomainManagment.Create')" 
          :disabled="fs.disabled('Node.DomainManagment.Create')"
          v-on:click.stop="()=>doActionOnNode('createSubdomain')"
        />
        <ToolButton 
          vertical light danger
          title="message.menu_delete_subdomain"
          icon="domain_disabled"
          tool-tip="message.menu_delete_subdomain"
          helptoken="Subdomain-management"
          v-if="node.is_root_of_subdomain && fs.show('Node.DomainManagment.Delete')" 
          :disabled="fs.disabled('Node.DomainManagment.Delete')"
          v-on:click.stop="()=>doActionOnNode('deleteSubdomain')"
        />
        <ToolButton 
          vertical light
          title="message.menu_users_subdomain"
          icon="group"
          tool-tip="message.menu_users_subdomain"
          helptoken="Subdomain-management"
          v-if="node.is_root_of_subdomain && fs.show('Node.DomainManagment.Members.View')" 
          :disabled="fs.disabled('Node.DomainManagment.Members.View')"
          v-on:click.stop="()=>doActionOnNode('subdomainUsers')"
        />
        <ToolButton 
          vertical light
          title="message.menu_roles_subdomain"
          icon="manage_accounts"
          tool-tip="message.menu_roles_subdomain"
          helptoken="Subdomain-management"
          v-if="(node.is_part_of_subdomain || node.is_root_of_subdomain) && fs.show('Node.DomainManagment.Role.View')" 
          :disabled="fs.disabled('Node.DomainManagment.Role.View')"
          v-on:click.stop="()=>doActionOnNode('subdomainRoles')"
        />
      </template>
    </CollapsedGroup>

    <CollapsedGroup class="buttons-group" innerClass="buttons-group-inner" v-if="!globalState.actVer && !globalState.projLock && (!node?.parent || !folder?.is_part) &&
          (folder || node)?.permissions?.can_i_write && !folder?.is_requirement && globalState.curUserRole !== 'urn:rdl:epm-std:project_member' && fs.show('Import')" 
          :hidden="collapsed.import" :ontoggle="()=>toggleCollapse('import')">
      <template #title>{{$t('message.btn_grp_import')}}</template>
      <template v-if="!node?.parent">
        <ToolButton 
        vertical
        title="message.menu_importCSV"
        icon="drive_folder_upload"
        tool-tip="message.menu_importCSV"
        helptoken="Import-CSV-file"
        v-if="fs.show('RootNode.ImportCSV')" 
        :disabled="fs.disabled('RootNode.ImportCSV')"
        v-on:click.stop="()=>doActionOnFolder('importCSVFileToProj')"
      />
      </template>
      <template v-else-if="!folder.is_part">
        <ToolButton 
          vertical
          title="message.menu_import"
          icon="drive_folder_upload"
          tool-tip="message.menu_import"
          helptoken="Import+from+STEP+PDM+file"
          v-if="fs.show('Node.ImportPDM')" 
          :disabled="fs.disabled('Node.ImportPDM')"
          v-on:click.stop="()=>doActionOnFolder('importFileToNode')"
        />
        <ToolButton 
          vertical
          title="message.menu_importAP242"
          icon="drive_folder_upload"
          tool-tip="message.menu_importAP242"
          helptoken="Import-from-AP242-Domain-model"
          v-if="fs.show('Node.ImportAP242')" 
          :disabled="fs.disabled('Node.ImportAP242')"
          v-on:click.stop="()=>doActionOnFolder('importAP242FileToNode')"
        />
        <ToolButton 
          vertical
          title="message.menu_importReqIF"
          icon="drive_folder_upload"
          tool-tip="message.menu_importReqIF"
          helptoken="Import+from+Req+IF+file"
          v-if="fs.show('Node.ImportReqIF')" 
          :disabled="fs.disabled('Node.ImportReqIF')"
          v-on:click.stop="()=>doActionOnNode('importReqIFToNode')"
        />
        <ToolButton 
          vertical
          title="message.menu_importTxt"
          icon="drive_folder_upload"
          tool-tip="message.menu_importTxt"
          helptoken="Import-from-text-file"
          v-if="fs.show('Node.ImportText')" 
          :disabled="fs.disabled('Node.ImportText')"
          v-on:click.stop="()=>doActionOnFolder('importTxtToNode')"
        />
        <ToolButton 
          vertical
          title="message.menu_importZipSys"
          icon="drive_folder_upload"
          tool-tip="message.menu_importZipSys"
          v-if="fs.show('Node.ImportZipFolder')" 
          :disabled="fs.disabled('Node.ImportZipFolder')"
          v-on:click.stop="()=>doActionOnFolder('importZipSysToNode')"
        />
        <ToolButton 
          vertical
          title="message.menu_importProj"
          icon="drive_folder_upload"
          tool-tip="message.menu_importProj"
          v-if="fs.show('Node.ImportProject')" 
          :disabled="fs.disabled('Node.ImportProject')"
          v-on:click.stop="()=>doActionOnFolder('importProjToNode')"
        />
      </template>
    </CollapsedGroup>

    <CollapsedGroup class="buttons-group" innerClass="buttons-group-inner" v-if="!globalState.actVer && (!node?.parent || !folder?.is_part) && 
          (folder || node)?.permissions?.can_i_write && !folder?.is_requirement && globalState.curUserRole !== 'urn:rdl:epm-std:project_member' && fs.show('Export')" 
          :hidden="collapsed.export" :ontoggle="()=>toggleCollapse('export')">
      <template #title>{{$t('message.btn_grp_export')}}</template>
      <template v-if="!node?.parent">
        <ToolButton 
          vertical
          title="message.menu_export"
          icon="cloud_download"
          tool-tip="message.menu_export"
          helptoken="Export-to-STEP-PDM-file"
          v-if="fs.show('RootNode.ExportToFile')" 
          :disabled="!node.permissions.can_i_read || fs.disabled('RootNode.ExportToFile')"
          v-on:click.stop="()=>doActionOnFolder('exportToFile')"
        />
        <ToolButton 
          vertical
          title="message.menu_export_txt"
          icon="cloud_download"
          tool-tip="message.menu_export_txt"
          helptoken="Export-structure-to-text-file"
          v-if="fs.show('RootNode.ExportToTxt')" 
          :disabled="!node.permissions.can_i_read || fs.disabled('RootNode.ExportToTxt')"
          v-on:click.stop="()=>doActionOnFolder('exportToTxt')"
        />
        <ToolButton 
          vertical
          title="message.menu_export_DEX"
          icon="cloud_download"
          tool-tip="message.menu_export_DEX"
          helptoken="Export-project-to-DEX"
          v-if="fs.show('RootNode.ExportToDEX')" 
          :disabled="!node.permissions.can_i_read || fs.disabled('RootNode.ExportToDEX')"
          v-on:click.stop="()=>doActionOnFolder('exportToDEX')"
        />
        <ToolButton 
          vertical
          title="message.menu_export_AP242"
          icon="cloud_download"
          tool-tip="message.menu_export_AP242"
          helptoken="Export-to-AP242-domain"
          v-if="fs.show('RootNode.ExportToAP242')" 
          :disabled="!node.permissions.can_i_read || fs.disabled('RootNode.ExportToAP242')"
          v-on:click.stop="()=>doActionOnFolder('exportToAP242')"
        />
      </template>
      <template v-else-if="!folder.is_part">
      <ToolButton 
        vertical
        title="message.menu_export_to_zip"
        icon="cloud_download"
        tool-tip="message.menu_export_to_zip"
        helptoken="Export-to-zipped-folder"
        v-if="fs.show('Node.ExportZipFolder')" 
        :disabled="fs.disabled('Node.ExportZipFolder')"
        v-on:click.stop="()=>doActionOnFolder('exportNodeToZip')"
      />
      <ToolButton 
        vertical
        title="message.menu_export_to_pdm"
        icon="cloud_download"
        tool-tip="message.menu_export_to_pdm"
        helptoken="Export-to-STEP-PDM-file"
        v-if="fs.show('Node.ExportPDM')" 
        :disabled="fs.disabled('Node.ExportPDM')"
        v-on:click.stop="()=>doActionOnFolder('exportNodeToPDM')"
      />
      <ToolButton 
        vertical
        title="message.menu_export_to_ap242"
        icon="cloud_download"
        tool-tip="message.menu_export_to_ap242"
        helptoken="Export-to-AP242-Domain"
        v-if="fs.show('Node.ExportAP242')" 
        :disabled="fs.disabled('Node.ExportAP242')"
        v-on:click.stop="()=>doActionOnFolder('exportNodeToAP242')"
      />
      </template>
    </CollapsedGroup>
  </div>
</template>

<script>
    import ToolButton from "./ToolButton.vue";
    import CollapsedGroup from "./CollapsedGroup.vue"

    import FeaturesSet from "@/utils/features";
    import{ conf } from '../utils/confTruePLM';

export default {
  name: 'actionsPanel',
  props: {
    folder: { 
      required: true
    },
    node: { 
      required: true
    },
    nodeType: {
      required: false,
      default: undefined
    }
  },
  components: {
    ToolButton,
    CollapsedGroup
  },
  data () 
  {
    return {
        fs: FeaturesSet,
        globalState: this.$globalStore.state,
        collapsed: {import: true, export:true},
        versionList: [],
        selectedVer: 0,
    };
  },
  watch:{
    
    node: function(){
      this.selectedVer = this.$globalStore.state.actVer>0 ? (this.$globalStore.state.actVer - 0) : (this.node?.version_id - 0);
    },
    /*
    nodeType:function(){
      console.log("Current node type:", this.nodeType);
    }*/
  },
  computed: {
    isNode: function(){
      return this.nodeType === 'node';
    },
    isFile: function(){
      return this.nodeType === 'file';
    },
    isProduct: function(){
      return this.nodeType === 'product';
    },
    isFolderProduct: function(){
      return this.nodeType === 'product' && !!this.folder?.elemID;
    },
    readyForPDF: function() {
        return ( this.node.data_type.toLowerCase() === '.docx' || ( this.globalState.initInfo.use_libre && 
            ( this.node.data_type.toLowerCase() === '.doc' ||  this.node.data_type.toLowerCase() === '.txt' 
            ||  this.node.data_type.toLowerCase() === '.cvs' ||  this.node.data_type.toLowerCase() === '.xls' 
            ||  this.node.data_type.toLowerCase() === '.xlsx' ) ) );
    },
    isConvType: function() {
        return ( this.node.data_type && 
                ( this.node.data_type.toLowerCase() === '.stp' || this.node.data_type.toLowerCase() === '.step' ) );
    },
    verList()
    {
        let vLs = [];
        let ls = this.versionList;

        for( let i = ls.length - 1; i > -1; i-- )
        {
            vLs.push( { txt: ( 'Ver. ' + ls[ i ] + ' ' ), val: parseInt( ls[ i ] ) } );
        }

        return vLs;
    },

  },
  methods: {
    
    havePasteFile(){
      return ( this.globalState.fileForPaste || this.globalState.fileForLink);
    },
    canPasteFile(){
      return ( this.globalState.fileForPaste && ( this.globalState.fileForPaste.parentNode.instance_id !== this.folder.instance_id ) )
              || ( this.globalState.fileForLink && ( this.globalState.fileForLink.parentNode.instance_id !== this.folder.instance_id ) )
    },
    doActionOnProductFolder(name){
      this.$eventBus.$emit( 'procRowMenuCmd', [name, this.folder.parent] );
    },
    doActionOnFolder(name){
      this.$eventBus.$emit( 'procRowMenuCmd', [name, this.folder] );
    },
    doActionOnNode(name){
      this.$eventBus.$emit( 'procRowMenuCmd', [name, this.node] );
    },
    toggleCollapse(name){
      this.collapsed[name] = !this.collapsed[name];
      this.$forceUpdate();
    },
    showHistory() {
      this.$modalDlg.sysDlgs.fileHistoryDlg.open( this.folder, this.node ).then( () => {}, () => {} );
    },
    showBOM(){
      this.$eventBus.$emit( 'showBOM', this.node );
    },
    showNodeTree(){
      this.$eventBus.$emit( 'showNodeTree' );
    },
    showNodeGraph(){
      let proj = conf.getProj();
      let url = '#/graphvis?';
      
      window.open( url + '&rep=' + proj.repository + '&model=' + proj.in_project.project_model_id 
              + '&node=' + this.node.instance_id + '&role=' + proj.userType, '_blank' );
    },
    setActVer(){
      this.$eventBus.$emit( 'setActVer', this.selectedVer );
    }
  },
  mounted: function() 
  { 
      this.$eventBus.$on( 'selectedModel', ( ) => {
        conf.versionList().then( ls => {
          this.versionList = ls;
          this.selectedVer = this.$globalStore.state.actVer>0 ? (this.$globalStore.state.actVer - 0) : (this.node?.version_id - 0);
          this.$forceUpdate();
        }).catch( ( err ) =>{
          this.versionList = [];
          this.$eventBus.$emit( 'queryError', err );
        });
      })
  }
}
</script>

<style scoped>
  .buttons-container{
    display: flex;
    flex-direction: column;
    gap: 4px;
  }
  .buttons-group{
    flex: 0 1;
    display: flex;
    flex-direction: column;
    border: 1px solid #eee;
    padding: 2px;
    border-radius: 6px;
    background-color: #f8f8f8;
  }
  >>>.buttons-group-inner{
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: center;
    align-content: center;
    row-gap: 4px;
    column-gap: 4px;
  }
  >>>.buttons-group-inner > span{
    flex: 1 1;
  }
  >>>.buttons-group-inner button{
    width: 100%;
    height: 50px;
    min-width: 50px;
    max-width: 300px;
  }
  >>>.buttons-group-inner .groupped-buttons{
    display: flex;
  }
  >>>.buttons-group-inner .groupped-buttons > span{
    flex: 1 1;
  }

  .version-selector.v-text-field{
    margin-top: 0;
  }
  .version-selector.v-text-field >>> .v-input__control{
    border-radius: 6px;
    padding: 6px;
    background-color: #e0e0e0;
    overflow: hidden;
  }
  .version-selector.v-text-field >>> .v-input__slot{
    border-radius: 6px;
    background-color: #fff;
    overflow: hidden;
    height: 38px;
  }
  .version-selector.v-text-field >>> input {
    padding: 8px 0 6px 8px !important;
  } 
  .version-selector.v-text-field >>> .v-input__append-inner{
    margin-top: 4px;
  }
</style>